/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Composer_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Ask a question (Enter to send, Shift+Enter for a new line)" |
*
* @param {Assistant_Composer_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_composer_placeholder = /** @type {((inputs?: Assistant_Composer_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Composer_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Poser une question (Appuyez sur Entrée pour envoyer, Maj+Entrée pour une nouvelle ligne)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stelle eine Frage (Eingabetaste zum Senden, Umschalt+Eingabetaste für eine neue Zeile)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Poni una domanda (Invio per inviare, Maiusc+Invio per andare a capo)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Задайте вопрос (нажмите Enter для отправки, Shift+Enter для переноса на новую строку)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haz una pregunta (Intro para enviar, Mayús+Intro para una nueva línea)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提出问题（按回车键发送，按Shift+回车键换行）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("質問を入力してください（Enterキーで送信、Shift+Enterで改行）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रश्न पूछें (भेजने के लिए एंटर दबाएं, नई पंक्ति के लिए Shift+Enter दबाएं)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faça uma pergunta (Pressione Enter para enviar, Shift+Enter para uma nova linha)")
	return /** @type {LocalizedString} */ ("Ask a question (Enter to send, Shift+Enter for a new line)")
});